import React, { ReactNode } from 'react';
import { useDrop } from 'react-dnd';
import styled from '@emotion/styled';
import itemsType from '../dragItemsType';

const Wrapper = styled.div<{
  selected: boolean;
  canDrop: boolean;
}>`
  height: 64px;
  position: relative;
  z-index: ${(props) => (props.canDrop ? 3 : 'auto')};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.24px;
  color: #fff;
  padding: 8px 12px 8px 8px;
  border-left: 4px solid transparent;
  border-left-color: ${(props) => (props.selected ? '#ffc000' : 'transparent')};
  border-bottom: 1px solid #1c232c;
  background: ${(props) =>
    props.selected
      ? 'linear-gradient(90deg, rgb(14, 18, 22) 0%, rgb(28, 35, 44) 100%)'
      : '#2f353d'};
`;

const Badge = styled.span`
  background-color: #e74c3c;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  padding: 0 2px 2px;
  border-radius: 4px;
  margin-left: 8px;
  min-width: 32px;
  text-align: center;
  box-sizing: border-box;
  display: inline-block;
  animation: bounce 5s ease-in-out 0s infinite;

  @keyframes bounce {
    0% {
      transform: scale(1);
    }
    5% {
      transform: scale(1.15);
    }
    10% {
      transform: scale(1);
    }
    15% {
      transform: scale(1.15);
    }
    20% {
      transform: scale(1);
    }
    100% {
      transform: scale(1);
    }
  }
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface Props {
  selectedNav: string;
  changeNav: (nav: string) => void;
  nav: string;
  children: ReactNode;
  incomingBookingsCount?: number;
}

const NavigationItem: React.FunctionComponent<Props> = ({
  selectedNav,
  changeNav,
  nav,
  children,
  incomingBookingsCount,
}) => {
  const [{ canDrop }, drop] = useDrop({
    accept: [itemsType.CHEQUE],
    hover: () => {
      if (selectedNav !== nav) {
        changeNav(nav);
      }
    },
    collect: (monitor) => ({
      canDrop: monitor.canDrop(),
    }),
  });

  return (
    <Wrapper
      canDrop={canDrop}
      ref={drop}
      selected={selectedNav === nav}
      onTouchStart={() => changeNav(nav)}>
      <Content>
        {children}
        {incomingBookingsCount !== undefined && incomingBookingsCount > 0 && (
          <Badge>{incomingBookingsCount}</Badge>
        )}
      </Content>
    </Wrapper>
  );
};

export default React.memo(NavigationItem);
